var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "flex-grow": "1",
        display: "flex",
        "flex-direction": "column",
        width: "100%",
      },
    },
    [
      _vm.$attrs.title
        ? _c(
            "div",
            { staticClass: "ice-title" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { separator: "/" } },
                [_c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$attrs.title))])],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: {
            "flex-grow": "1",
            display: "flex",
            "flex-direction": "row",
            width: "100%",
          },
        },
        [
          _c(
            "ice-tree",
            _vm._b(
              {
                ref: "tree",
                on: {
                  "node-click": _vm.handleNodeClick,
                  "node-check": _vm.nodeCheck,
                },
              },
              "ice-tree",
              _vm.$attrs,
              false
            ),
            [_vm._t("prefix", null, { slot: "prefix" })],
            2
          ),
          _c(
            "div",
            { staticClass: "editableArea" },
            [
              _c(
                "ice-query-grid",
                _vm._g(
                  _vm._b(
                    {
                      ref: "queryGrid",
                      attrs: {
                        resize: false,
                        "grid-auto-refresh": false,
                        lazy: false,
                        "before-bind-data": _vm.dataFilter,
                      },
                    },
                    "ice-query-grid",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              ),
              _vm._t("bottom"),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }